export const selectProductDetailPage = (state) => state.productDetails;
